import { render, staticRenderFns } from "./ArancelPrecios.vue?vue&type=template&id=566df172&"
import script from "./ArancelPrecios.vue?vue&type=script&lang=js&"
export * from "./ArancelPrecios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports